<template>
  <div class="tab-content">
    <div class="mb-8">
      <div>
        <h2 class="text-2xl font-bold text-gray-900 mb-2 flex items-center">
          <font-awesome-icon icon="building" class="mr-3 text-blue-600" />
          Institutions & Campuses
        </h2>
        <p class="text-gray-500">View educational institutions and their campuses</p>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="text-center py-12">
      <base-page-spinner type="spin" class-list="h-12"></base-page-spinner>
      <p class="text-gray-500 mt-4">Loading institutions and campuses...</p>
    </div>

    <!-- Institutions List -->
    <div v-else>
      <div v-if="institutions && institutions.length > 0" class="space-y-6">
        <div v-for="institution in institutions" :key="institution.id"
          class="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg hover:border-blue-300 transition-all duration-300">
          <div class="flex items-center mb-4">
            <div class="bg-blue-600 rounded-xl p-3 mr-4 shadow-lg">
              <font-awesome-icon icon="university" class="text-white text-xl" />
            </div>
            <div>
              <h3 class="text-xl font-bold text-gray-900">{{ institution.name }}</h3>
              <p class="text-sm text-gray-500">
                {{ institution.campuses && institution.campuses.length ? institution.campuses.length : 0 }}
                Campus{{ institution.campuses && institution.campuses.length !== 1 ? 'es' : '' }}
              </p>
            </div>
          </div>

          <!-- Campuses -->
          <div v-if="institution.campuses && institution.campuses.length > 0"
            class="ml-12 mt-4 pt-4 border-t border-gray-200">
            <h4 class="text-lg font-semibold text-gray-700 flex items-center mb-4">
              <font-awesome-icon icon="map-marker-alt" class="mr-2 text-blue-600" />
              Campuses
            </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              <div v-for="campus in institution.campuses" :key="campus.id"
                class="bg-white border border-gray-200 rounded-lg p-4 flex items-center hover:shadow-md hover:border-blue-300 transition-all duration-200">
                <div class="flex items-center flex-1">
                  <div class="bg-blue-100 rounded-lg p-2 mr-3">
                    <font-awesome-icon icon="map-pin" class="text-blue-600 text-sm" />
                  </div>
                  <span class="text-sm font-medium text-gray-700">{{ campus.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="ml-12 mt-4 pt-4 border-t border-gray-200">
            <p class="text-sm text-gray-500 italic">No campuses found for this institution</p>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="text-center py-12 bg-gray-50 rounded-xl">
        <font-awesome-icon icon="building" class="text-4xl text-gray-400 mb-4" />
        <p class="text-gray-500">No institutions found</p>
        <p class="text-sm text-gray-400 mt-2">Please check your backend connection and ensure data is available.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstitutionsTab',
  props: {
    institutions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
